import 'scrolltofixed';

const header = document.getElementById('js-main-header');
let headerHeight = header.offsetHeight - 24;

let $limit = $('.js-fixed-el-limit');
if ($limit.length < 1) {
    $limit = $('#js-main-footer');
}
const $fixedEl = $('.js-fixed-el');

$fixedEl.scrollToFixed({
    marginTop: headerHeight,
    zIndex: 1,
    minWidth: 992,
    removeOffsets: true,
    limit: function () {
        let limit = $limit.offset().top - this.outerHeight(true) - 120;
        return limit;
    },
});
